export const MAINTENANCE_SET_UPCOMING = 'MAINTENANCE_SET_UPCOMING';

export function setUpcomingMaintenance(maintenance) {
  return {
    type: MAINTENANCE_SET_UPCOMING,
    payload: maintenance
  };
}
